import { render, staticRenderFns } from "./PublicTechnicalList.vue?vue&type=template&id=41136472&scoped=true&"
import script from "./PublicTechnicalList.vue?vue&type=script&lang=js&"
export * from "./PublicTechnicalList.vue?vue&type=script&lang=js&"
import style0 from "./PublicTechnicalList.vue?vue&type=style&index=0&id=41136472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41136472",
  null
  
)

export default component.exports